module.exports = __webpack_public_path__ + "static/media/done.feec7444.svg";